const S3_AVATAR_BASE = 'https://s3-sa-east-1.amazonaws.com/recrutai-dev/';

/**
 * FEAT TEMPORÁRIA: mapa de contas autorizadas a exibir o botão de troca de ambiente.
 * Chave: unique_name ou account_id (UUID).
 * Valor: url de destino + avatar do agente (path S3, sem fetch).
 */
const ACCOUNT_SWITCH_CONFIG = {
  petlove: {
    avatarUrl:
      S3_AVATAR_BASE +
      '55bdbc90-fb53-11ef-9f40-874e391c3372/accountUser/8873/avatar_55bdbc90-fb53-11ef-9f40-874e391c3372_8873_1744668347274_50.jpg',
    url: 'https://petlove2.rd.recrut.ai'
  }
};

/**
 * Retorna a config de troca de ambiente se algum identificador estiver no mapa.
 * @param {...(string|null|undefined)} identifiers - unique_name e/ou account_id
 * @returns {{ url: string, avatarUrl?: string }|null}
 */
export function getAccountSwitchConfig(...identifiers) {
  for (const id of identifiers) {
    if (id && ACCOUNT_SWITCH_CONFIG[id]) {
      return ACCOUNT_SWITCH_CONFIG[id];
    }
  }

  return null;
}
